import { AiRequestMetadataInput } from "@/modules/patients/detail/progress-note/services/ch/__generated__/chChatHistorySummarizerQuery.graphql"
import { chChatHistorySummarizerQuery } from "@/modules/patients/detail/progress-note/services/ch/chChatHistorySummarizerQuery"
import { deChatHistorySummarizerQuery } from "@/modules/patients/detail/progress-note/services/de/deChatHistorySummarizerQuery"
import { Country } from "@/types/__generated__/union-types"

export const chatHistorySummarizerQuery = (country: Country, aiRequestMetadata: AiRequestMetadataInput) => {
  if (country === "DE") {
    return deChatHistorySummarizerQuery(aiRequestMetadata)
  }
  return chChatHistorySummarizerQuery(aiRequestMetadata)
}
